// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AvisoLegalRouteImport } from './routes/aviso-legal'
import { Route as BlogRouteImport } from './routes/blog'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as CookiesRouteImport } from './routes/cookies'
import { Route as PaqueteConfirmadoRouteImport } from './routes/paquete-confirmado'
import { Route as PrivacidadRouteImport } from './routes/privacidad'
import { Route as ReservaConfirmadaRouteImport } from './routes/reserva-confirmada'
import { Route as ServicesRouteImport } from './routes/services'
import { Route as AboutIndexRouteImport } from './routes/about.index'
import { Route as AboutEquipoRouteImport } from './routes/about.equipo'
import { Route as AboutMisionRouteImport } from './routes/about.mision'
import { Route as AboutOficinasRouteImport } from './routes/about.oficinas'
import { Route as BlogIndexRouteImport } from './routes/blog.index'
import { Route as BlogSlugRouteImport } from './routes/blog.$slug'
import { Route as ProductsSlugRouteImport } from './routes/products.$slug'
import { Route as ServicesIndexRouteImport } from './routes/services.index'
import { Route as ServicesAreasRouteImport } from './routes/services.areas'
import { Route as ServicesCasosRouteImport } from './routes/services.casos'
import { Route as ServicesPaquetesRouteImport } from './routes/services.paquetes'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const AvisoLegalRoute = AvisoLegalRouteImport.update({
            id: '/aviso-legal',path: '/aviso-legal',getParentRoute: () => rootRouteImport
          })
const BlogRoute = BlogRouteImport.update({
            id: '/blog',path: '/blog',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const CookiesRoute = CookiesRouteImport.update({
            id: '/cookies',path: '/cookies',getParentRoute: () => rootRouteImport
          })
const PaqueteConfirmadoRoute = PaqueteConfirmadoRouteImport.update({
            id: '/paquete-confirmado',path: '/paquete-confirmado',getParentRoute: () => rootRouteImport
          })
const PrivacidadRoute = PrivacidadRouteImport.update({
            id: '/privacidad',path: '/privacidad',getParentRoute: () => rootRouteImport
          })
const ReservaConfirmadaRoute = ReservaConfirmadaRouteImport.update({
            id: '/reserva-confirmada',path: '/reserva-confirmada',getParentRoute: () => rootRouteImport
          })
const ServicesRoute = ServicesRouteImport.update({
            id: '/services',path: '/services',getParentRoute: () => rootRouteImport
          })
const AboutIndexRoute = AboutIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AboutRoute
          })
const AboutEquipoRoute = AboutEquipoRouteImport.update({
            id: '/equipo',path: '/equipo',getParentRoute: () => AboutRoute
          })
const AboutMisionRoute = AboutMisionRouteImport.update({
            id: '/mision',path: '/mision',getParentRoute: () => AboutRoute
          })
const AboutOficinasRoute = AboutOficinasRouteImport.update({
            id: '/oficinas',path: '/oficinas',getParentRoute: () => AboutRoute
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => BlogRoute
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => BlogRoute
          })
const ProductsSlugRoute = ProductsSlugRouteImport.update({
            id: '/products/$slug',path: '/products/$slug',getParentRoute: () => rootRouteImport
          })
const ServicesIndexRoute = ServicesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ServicesRoute
          })
const ServicesAreasRoute = ServicesAreasRouteImport.update({
            id: '/areas',path: '/areas',getParentRoute: () => ServicesRoute
          })
const ServicesCasosRoute = ServicesCasosRouteImport.update({
            id: '/casos',path: '/casos',getParentRoute: () => ServicesRoute
          })
const ServicesPaquetesRoute = ServicesPaquetesRouteImport.update({
            id: '/paquetes',path: '/paquetes',getParentRoute: () => ServicesRoute
          })





const AboutRouteChildren = {
  AboutEquipoRoute: AboutEquipoRoute,AboutMisionRoute: AboutMisionRoute,AboutOficinasRoute: AboutOficinasRoute,AboutIndexRoute: AboutIndexRoute
}

const AboutRouteWithChildren = AboutRoute._addFileChildren(AboutRouteChildren)




const BlogRouteChildren = {
  BlogSlugRoute: BlogSlugRoute,BlogIndexRoute: BlogIndexRoute
}

const BlogRouteWithChildren = BlogRoute._addFileChildren(BlogRouteChildren)




const ServicesRouteChildren = {
  ServicesAreasRoute: ServicesAreasRoute,ServicesCasosRoute: ServicesCasosRoute,ServicesPaquetesRoute: ServicesPaquetesRoute,ServicesIndexRoute: ServicesIndexRoute
}

const ServicesRouteWithChildren = ServicesRoute._addFileChildren(ServicesRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutRoute: AboutRouteWithChildren,AvisoLegalRoute: AvisoLegalRoute,BlogRoute: BlogRouteWithChildren,ContactRoute: ContactRoute,CookiesRoute: CookiesRoute,PaqueteConfirmadoRoute: PaqueteConfirmadoRoute,PrivacidadRoute: PrivacidadRoute,ReservaConfirmadaRoute: ReservaConfirmadaRoute,ServicesRoute: ServicesRouteWithChildren,ProductsSlugRoute: ProductsSlugRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)